/*
* 字典数据
* */

// 咨询类型
export const consult_type = [
  {
    value: 1,
    label: '随便聊聊'
  },
  {
    value: 2,
    label: '交流些技术（或业务）'
  },
  {
    value: 3,
    label: '请教些知识'
  },
  {
    value: 4,
    label: '求帮解决问题'
  }
]
// 预约单状态
export const status = [
  {
    value: 0,
    label: '待接受'
  },
  {
    value: 1,
    label: '待开始'
  },
  {
    value: 2,
    label: '进行中'
  },
  {
    value: 3,
    label: '已完成'
  },
  {
    value: 4,
    label: '已拒绝'
  },
  {
    value: 5,
    label: '已取消'
  },
]
// 修改预约记录状态
export const modify_appointment_history_status = [
  {
    value: 0,
    label: '待处理'
  },
  {
    value: 1,
    label: '已同意'
  },
  {
    value: 2,
    label: '已拒绝'
  },
  {
    value: 3,
    label: '已建议新时间'
  },
]
// 咨询室-修改时间dialog-发起方
export const initiator_type = [
  {
    value: 1,
    label: '承约人'
  },
  {
    value: 2,
    label: '预约人'
  }
]
// 咨询室-举报类型
export const report_type = [
  {
    value: 0,
    label: '信息作假'
  },
  {
    value: 1,
    label: '态度恶劣'
  },
  {
    value: 2,
    label: '诈骗'
  },
  {
    value: 3,
    label: '抄袭'
  },
  {
    value: 4,
    label: '违规（色情、暴力、涉政）'
  },
  {
    value: 5,
    label: '其它'
  },
]
export default {
  consult_type,
  status,
  modify_appointment_history_status,
  initiator_type,
  report_type
}
